(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bb-panel-ugc-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    var lightbox = null;

    function ensureLightbox() {
      if (lightbox) return lightbox;
      lightbox = document.createElement('div');
      lightbox.className = 'bb-panel-ugc__lightbox';
      lightbox.innerHTML =
        '<div class="bb-panel-ugc__lightbox-backdrop" data-bb-pugc-lightbox-close></div>' +
        '<div class="bb-panel-ugc__lightbox-content">' +
          '<button class="bb-panel-ugc__lightbox-close" type="button" aria-label="Close" data-bb-pugc-lightbox-close>' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
          '<div class="bb-panel-ugc__lightbox-stage" data-bb-pugc-lightbox-stage></div>' +
        '</div>';
      document.body.appendChild(lightbox);

      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-bb-pugc-lightbox-close]')) {
          closeLightbox();
        }
      });

      return lightbox;
    }

    function openLightbox(content) {
      var lb = ensureLightbox();
      var stage = lb.querySelector('[data-bb-pugc-lightbox-stage]');
      stage.innerHTML = '';

      if (content.type === 'video') {
        var video = document.createElement('video');
        video.src = content.src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        stage.appendChild(video);
      } else {
        var img = document.createElement('img');
        img.src = content.src;
        if (content.srcset) img.srcset = content.srcset;
        img.alt = '';
        stage.appendChild(img);
      }

      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      var stage = lightbox.querySelector('[data-bb-pugc-lightbox-stage]');
      var video = stage.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      stage.innerHTML = '';
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.bb-panel-ugc__card');
      if (!card) return;

      if (card.classList.contains('is-video')) {
        var v = card.querySelector('video');
        if (!v) return;
        var source = v.querySelector('source');
        var src = source ? source.src : (v.currentSrc || v.src);
        if (src) openLightbox({ type: 'video', src: src });
      } else {
        var img = card.querySelector('img');
        if (!img) return;
        openLightbox({
          type: 'image',
          src: img.currentSrc || img.src,
          srcset: img.srcset
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
